//#region src/kiosk_cash_machine_status.ts
let KioskCashMachineStatus = /* @__PURE__ */ function(KioskCashMachineStatus) {
	KioskCashMachineStatus["Available"] = "available";
	KioskCashMachineStatus["InUse"] = "in-use";
	KioskCashMachineStatus["LowInventory"] = "low-inventory";
	KioskCashMachineStatus["Disconnected"] = "disconnected";
	KioskCashMachineStatus["Error"] = "error";
	KioskCashMachineStatus["NeedsVerification"] = "needs-verification";
	return KioskCashMachineStatus;
}({});
//#endregion
export { KioskCashMachineStatus };

//# sourceMappingURL=kiosk_cash_machine_status.js.map